export function priceFormat(value: number): string {
  return new Intl.NumberFormat('JPY', {
    style: 'currency',
    currency: 'JPY',
  }).format(value);
}
